import { ChangeDetectorRef, Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { CompetenciesService } from '../competencies/competencies.service';
import { MatSort } from '@angular/material/sort';
import { AddDialogComponent } from 'src/app/components/add-dialog/add-dialog.component';
import { DialogForCompetencyComponent } from 'src/app/components/dialog-for-competency/dialog-for-competency.component';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { OrganizationalComplianceCreationComponent } from '../organizational-compliance-creation/organizational-compliance-creation.component';
import { auto } from '@popperjs/core';
import { AddProposalService } from '../proposals/add-proposal/add-proposal.service';
import { DeleteDialogComponent } from 'src/app/components/delete-dialog/delete-dialog.component';
import saveAs from 'file-saver';
import { MatTabChangeEvent } from '@angular/material/tabs'; import { GraphService } from 'src/app/services/Organization/graph.service';
import { Router } from '@angular/router';


@Component({
  selector: "app-organizational-compliance",
  templateUrl: "./organizational-compliance.component.html",
  styleUrls: ["./organizational-compliance.component.css"],
})
export class OrganizationalComplianceComponent implements OnInit {
  from: any = 0;
  size: any = 20;
  regions: any = [];
  barnches: any = [];
  headerRegions: any = [];
  headerCities: any = [];
  public locations: any = [];
  location = "Locations:";
  displayedColumns: string[] = ["complianceName", "complianceType", "actions"];
  cities: string[] = [];
  officeLocations: any = [];
  headerOfficeLocations: any = [];
  headerRegionsNew: any = [];
  sortedData: any = [];
  selectedCountry: string = "";
  selectedCity: string = "";
  selectedOfficeLocation: string = "";
  public searchText: string = "";
  loading: boolean = true;
  totalRecords: number = 0;
  private complianceId: any;
  private regionId: any;
  private countryId: any;
  private cityId: any;
  years: number[] = [];
  selectedYear = new Date().getFullYear();
  a: any = [];
  locName = [];
  currentDate = new Date().toISOString();
  dialogRef: any;
  public dataSource: MatTableDataSource<any>;
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild("myInfoDialog") infoDialog = {} as TemplateRef<string>;
  headerRegionsTab: any = [];

  constructor(
    public dialog: MatDialog,
    private cd: ChangeDetectorRef,
    private _addProposalService: AddProposalService,
    private toastr: ToastrService,
    private _graphService: GraphService,
    private router: Router
  ) {}

  async ngOnInit() {
    await this.initialzeData();
    this.years = this.generateYearsArray(2024, new Date().getFullYear());
    this.sortedData = this.headerRegionsNew;
    this.displayedColumns = this.getDisplayedColumns();
  }

  async initialzeData() {
    try {
      let regions = await this.getAllRegionsForHeader();
      this.headerRegionsNew = regions;
      this.headerRegionsNew.forEach((x) => {
        this.headerRegionsTab.push({ name: x.name });
      });
      this.headerRegionsTab.push({ name: "All" });
    } catch (error) {}
  }

  checkCompliance(element, location) {
    const certifications = element.certifications || [];
    const locationType = location.name;
    if (certifications.length === 0 && element.locationName === location.name) {
      return "check_circle";
    }
    for (const cert of certifications) {
      if (
        cert.type.includes(locationType) ||
        element.locationName === location.name
      ) {
        return "check_circle";
      }
    }
    return "cancel";
  }
  clearSearchText() {
    this.searchText = "";
    this.applyFilter(this.searchText);
  }
  getCountryData(data: MatTabChangeEvent) {
    if (data.tab.textLabel !== "All") {
      let allData = this.headerRegionsNew.slice();
      this.sortedData = allData.filter((x) => x.name === data.tab.textLabel);
    } else {
      this.sortedData = this.headerRegionsNew.slice();
    }
    this.displayedColumns = this.getDisplayedColumns();
    this.getAllCompliancesByFilter();
  }
  transformData(regions, cities, locations) {
    return regions.map((region) => ({
      ...region,
      countries: region.subCompetencies.map((country) => ({
        ...country,
        cities: cities
          .filter(
            (city) =>
              city.competencyId === region.id &&
              city.subCompetencyId === country.id
          )
          .map((city) => ({
            ...city,
            locations: locations.filter(
              (location) => location.cityId === city.id
            ),
          })),
      })),
    }));
  }

  getDisplayedColumns() {
    return [
      "complianceName",
      "complianceType",
      ...this.getOfficeHeaders(),
      "Actions",
    ];
  }

  getTotalColspan() {
    return this.sortedData.reduce((acc, region) => {
      return (
        acc +
        region.countries.reduce((innerAcc, country) => {
          return (
            innerAcc +
            country.cities.reduce((deepAcc, city) => {
              return deepAcc + city.locations.length;
            }, 0)
          );
        }, 0)
      );
    }, 0);
  }

  getCountryColspan(region) {
    return region.countryList.reduce((acc, country) => {
      return (
        acc +
        country.cityList.reduce((innerAcc, city) => {
          return innerAcc + city.locationList.length;
        }, 0)
      );
    }, 0);
  }
  getCityColspan(country) {
    return country.cityList.reduce((acc, city) => {
      return acc + city.locationList.length;
    }, 0);
  }

  getOfficeColspan(city) {
    return city.locationList.length;
  }

  getRegionHeaders() {
    return this.sortedData.map((region) => region.name);
  }

  getCountryHeaders() {
    let allData = this.sortedData.flatMap((region) =>
      region.countryList.map((country) => country.name)
    );
    return ["complianceName", "complianceType", ...allData, "Actions"];
  }

  getCityHeaders() {
    return this.sortedData.flatMap((region) =>
      region.countryList.flatMap((country) =>
        country.cityList.map((city) => city.name)
      )
    );
  }

  getOfficeHeaders() {
    return this.sortedData.flatMap((region) =>
      region.countryList.flatMap((country) =>
        country.cityList.flatMap((city) =>
          city.locationList.map((location) => location.name)
        )
      )
    );
  }

  async getAllRegionsForHeader(): Promise<any[]> {
    return new Promise<any[]>((resolve, reject) => {
      this._addProposalService.getAllRegions().subscribe(
        (res) => {
          this.headerRegions = res.data;
          resolve(res.data);
        },
        (error) => {
          reject(error);
        }
      );
    });
  }

  async getAllCitiesForHeader(): Promise<any[]> {
    return new Promise<any[]>((resolve, reject) => {
      this._addProposalService.getAllCitiesForHeader().subscribe(
        (res) => {
          this.headerCities = res.data;
          resolve(res.data);
        },
        (error) => {
          reject(error);
        }
      );
    });
  }

  async getAllOfficeLocationsForHeader(): Promise<any[]> {
    return new Promise<any[]>((resolve, reject) => {
      this._addProposalService.getAllOfficeLocationsForHeader().subscribe(
        (res) => {
          this.headerOfficeLocations = res.data;
          resolve(res.data);
        },
        (error) => {
          reject(error);
        }
      );
    });
  }

  getCities1(regionId: number, countryId: number) {
    let search = "";
    this._addProposalService
      .getCityByCountryId(regionId, countryId, search)
      .subscribe(
        (res) => {
          const key = `${regionId}-${countryId}`;
          this.headerCities[key] = res.data;
          this.headerCities[key].forEach((city) => {
            this.getOfficeLocations(regionId, countryId, city.id);
          });
        },
        (error) => {}
      );
  }

  getOfficeLocations(regionId: number, countryId: number, cityId: string) {
    let search = "";
    this._addProposalService
      .getLocationsByCountryId(regionId, countryId, search, cityId)
      .subscribe(
        (res) => {
          const key = `${regionId}-${countryId}-${cityId}`;
          this.headerOfficeLocations[key] = res.data;
        },
        (error) => {}
      );
  }

  async getRegions(): Promise<any[]> {
    return new Promise<any[]>((resolve, reject) => {
      this._addProposalService.getAllRegions().subscribe((x) => {
        this.headerRegions = x.data;
        var ids = this.regions.map((item) => item.id);
        x.data.forEach((loc) => {
          if (!ids.includes(loc.id)) {
            this.regions.push(loc);
          }
        });
        resolve(this.regions);
      });
    });
  }

  generateYearsArray(startYear: number, endYear: number): number[] {
    const years = [];
    for (let year = startYear; year <= endYear; year++) {
      years.push(year);
    }
    return years;
  }

  regionChange(value) {
    this.regionId = value;
    this.loading = true;
    this.countryId = null;
    this.cityId = null;
    this.cities = [];
    this.barnches = [];
    if (parseInt(value) > 0) {
      this._addProposalService.getCountryByRegionId(parseInt(value)).subscribe(
        (res) => {
          this.barnches = res.data;
        },
        (error) => {}
      );
    }
    this.getAllCompliancesByFilter();
  }

  countryChange(value) {
    this.countryId = value;
    this.loading = true;
    this.cityId = null;
    let search = "";
    this.cities = [];
    if (parseInt(this.regionId) > 0 && parseInt(this.countryId)) {
      this._addProposalService
        .getCityByCountryId(
          parseInt(this.regionId),
          parseInt(this.countryId),
          search
        )
        .subscribe(
          (res) => {
            this.cities = res.data;
          },
          (error) => {}
        );
    }
    this.getAllCompliancesByFilter();
  }

  cityChange(value) {
    this.cityId = value;
    this.loading = true;
    this.getAllCompliancesByFilter();
  }

  yearChange(value) {
    this.selectedYear = value;
    this.getAllCompliancesByFilter();
  }

  getAllCompliancesByFilter() {
    return this._addProposalService
      .getAllCompliancesByFilter(
        this.from,
        this.size,
        this.countryId,
        this.regionId,
        this.cityId,
        this.searchText,
        this.selectedYear
      )
      .subscribe((x) => {
        this.dataSource = new MatTableDataSource(
          this.preprocessCompliances(x.data.compilances)
        );
        this.dataSource.sort = this.sort;
        this.totalRecords = x.data.totalCount;
        this.loading = false;
      });
  }

  preprocessCompliances(compliances) {
    return compliances.map((element) => {
      element.locationClasses = this.getLocationClasses(element);
      return element;
    });
  }

  getLocationClasses(element) {
    let classes = {};
    this.locName = [];
    let certifications = element.certifications || [];
    let locationName = element.locationName;
    let locationMap: any[] = [];
    element.certifications?.forEach((c) => {
      let str = [];
      c.regionList?.forEach((region) => {
        region.countryList?.forEach((country) => {
          country.cityList?.forEach((city) => {
            city.locationList?.forEach((location) => {
              locationMap.push({
                location: location.name,
                region: region.name,
                country: country.name,
                city: city.name,
                isApplicable: location.isApplicable,
              });
            });
          });
        });
      });
      this.locName.push({ locationName: str.join(", "), fileName: c.name });
    });
    locationMap.forEach((loc) => {
      let className = "cancel";
      if (loc.isApplicable) {
        className = "check_circle";
      }
      classes[loc.location] = className;
    });
    return classes;
  }

  getLocationsInDownload(data) {
    this.locName = [];
    data?.forEach((c) => {
      let str = [];
      c.regionList?.forEach((region) => {
        region.countryList?.forEach((country) => {
          country.cityList?.forEach((city) => {
            city.locationList?.forEach((location) => {
              str.push(location.name);
            });
          });
        });
      });
      this.locName.push({
        locationName: str.join(", "),
        fileName: c.name,
        fileId: c.fileId,
      });
    });
  }
  OpenCompDialog() {
    this.router.navigate(["Home/Compliance/Add-Compliance"], {
      state: {
        width: "800px",
        height: auto,
        panelClass: "view-file",
        data: { title: "Add " },
      },
    });
  }

  GetComplianceData() {
    this.loading = true;
    return this._addProposalService
      .GetComplianceData(this.searchText, this.from, this.size)
      .subscribe((x) => {
        this.dataSource = new MatTableDataSource(x.data.compilances);
        this.dataSource.sort = this.sort;
        this.totalRecords = x.data.totalCount;
        this.loading = false;
      });
  }

  getPaginatorData(event) {
    if (event.previousPageIndex > event.pageIndex) {
      this.from = event.pageIndex * this.size;
      this.size = event.pageSize;
    } else {
      this.size = event.pageSize;
      this.from = event.pageIndex * this.size;
    }
    this.getAllCompliancesByFilter();
  }

  edit(data) {
    this.router.navigate(["Home/Compliance/edit/", data.id], {
      state: {
        data: { title: "Edit " },
      },
    });
  }

  view(data) {
    this.router.navigate(["Home/Compliance/view/", data.id, { isView: true }], {
      state: {
        data: { title: "View " },
      },
    });
  }

  delete(data) {
    const dialogRef = this.dialog.open(DeleteDialogComponent, {
      width: auto,
      minWidth: "550px",
      height: auto,
      data: {
        name: data.customerName,
        title: "Delete Compliance",
      },
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.loading = true;
        this.deleteComplianceCard(data.id);
      }
    });
  }

  deleteComplianceCard(id) {
    this._addProposalService.delComilanceData(id).subscribe((res) => {
      this.toastr.success("Details Deleted Successfully");
      this.cd.detectChanges();
      setTimeout(() => {
        this.getAllCompliancesByFilter();
      }, 1000);
    });
  }

  download(doc) {
    const data = { id: doc.id };
    this.complianceId = data.id;
    if (doc.certificationsCount == 0) {
      this.toastr.error("No files to download");
    } else {
      this.getLocationsInDownload(doc.certifications);
      this.dialogRef = this.dialog.open(this.infoDialog, {
        data: { totaldata: doc.certifications, names: doc.compilanceName },
        height: auto,
        width: "40rem",
      });
      this.dialogRef.afterClosed().subscribe(() => {});
    }
  }

  downloadProposalArtifacts(doc) {
    this._graphService.getDownloadUrl1(doc.fileId, "").subscribe((res) => {
      saveAs(res.url, doc.name);
    });
  }

  applyFilter(filterValue: string) {
    this.searchText = filterValue;
    this.from = 0;
    this.size = 20;
    this.getAllCompliancesByFilter();
  }
}

